import { openTelemetry } from "@/lib/open-telemetry";

openTelemetry.initialize();
